import { ReactComponent as IconLightning } from './icon_lightning.svg';
import { ReactComponent as IconBook } from './icon_book.svg';
import { ReactComponent as IconStar } from './icon_star.svg';

export const inlineSvgMapping = {
  icon_lightning: IconLightning,
  icon_book: IconBook,
  icon_star: IconStar,
};

export type TeachingLearningSequenceSvgIds = keyof typeof inlineSvgMapping;

type Props = {
  id: TeachingLearningSequenceSvgIds;
  width?: string | number;
  height?: string | number;
  className?: string;
};

const TeachingLearningSequenceInlineSvg = (props: Props) => {
  const Svg = inlineSvgMapping[props.id];
  return (
    <Svg
      focusable="false"
      width={props.width || 16}
      height={props.height || 16}
      {...props}
    />
  );
};

export default TeachingLearningSequenceInlineSvg;
